import React from 'react'
import logo from '../../assets/images/Logo.png'
import img1 from '../../assets/images/social.png'
import img2 from '../../assets/images/social2.png'
import img3 from '../../assets/images/socia3.png'
import img4 from '../../assets/images/socia4.png'
import img5 from '../../assets/images/footerimg.png'

const Footer = () => {
  return (
    <div className='footerdiv'>
      <div className='row'>
        <div className='col'>
          <img src={logo} className='footerlogo'></img>
        </div>
        <div className='col'>
          <p><strong>Links</strong></p>
          <a href='/home' style={{textDecoration:"none",underline:"none" }}><p>Home</p></a>
          <a href='/myProfile' style={{textDecoration:"none",underline:"none" }}><p>My Profile</p></a>
          <a href='#' style={{textDecoration:"none",underline:"none" }}><p>Notification</p></a>
        </div>
        {/* <div className='col'>
          <p><strong>Support</strong></p>
          <p>About Us</p>
          <p>Support</p>
        </div> */}
        <div className='col'>
          <p><strong>Address</strong></p>
          <p>P 11/90, First Floor, Outer Circle, Connaught Place, New Delhi, 110001
          Tel: 093110 67486, 093158 17343, 011 4352 8138</p>
         
        </div>
        <div className='col'>
          <p><strong>Please Connect</strong></p>
          <p>mbaguru@rootseducation.com</p>
          <div className='d-flex'>
          <a href='https://www.facebook.com/mbaguru?mibextid=ZbWKwL'><img src={img1} className='p-3'/></a>
          <a href='https://www.instagram.com/mbaguruofficial?igsh=MWR0enk5OTBjajEwNw==' target='_blank'><img src={img2} className='p-3'/></a>
          <a href="https://www.youtube.com/@mbaguruadaptive" target="_blank">
          <img src={img3} className='p-3'/></a>
          {/* <img src={img4} className='p-3'/> */}
      </div>
        </div>
      </div>
        <div>
          <img src={img5} style={{width:"100%"}}></img>
        </div>
     
    </div>
  )
}

export default Footer

// import React, { useRef, useState, useEffect } from 'react';

// const CaptureImage = () => {
//   const videoRef = useRef(null);
//   const canvasRef = useRef(null);
//   const [imageURL, setImageURL] = useState(null);

//   // Start the camera when the component mounts
//   useEffect(() => {
//     navigator.mediaDevices
//       .getUserMedia({ video: true })
//       .then(stream => {
//         videoRef.current.srcObject = stream;
//       })
//       .catch(error => console.error("Error accessing the camera: ", error));
//   }, []);

//   const captureImage = () => {
//     const video = videoRef.current;
//     const canvas = canvasRef.current;

//     if (canvas && video) {
//       const context = canvas.getContext('2d');
//       canvas.width = video.videoWidth;
//       canvas.height = video.videoHeight;
//       context.drawImage(video, 0, 0, canvas.width, canvas.height);

//       // Create a blob from the canvas
//       canvas.toBlob(blob => {
//         const url = URL.createObjectURL(blob); // Create a URL for the blob
//         setImageURL(url); // Set the URL in the state to display or use
//       }, 'image/png');
//     }
//   };

//   return (
//     <div>
//       <video ref={videoRef} autoPlay playsInline style={{ display: 'block', width: '100%' }}></video>
//       <button onClick={captureImage}>Capture Image</button>
//       <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
//       {imageURL && (
//         <div>
//           <p>Captured Image:</p>
//           <img src={imageURL} alt="Captured" />
//         </div>
//       )}
//     </div>
//   );
// };

// export default CaptureImage;
